import axios from 'axios';
import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

const apiBase = process.env.REACT_APP_API_BASE_URL;

const unwrapPublicResponse = (response) => {
  const body = response.data;

  if (!body?.success) {
    const error = new Error(body?.message || 'Request failed');
    error.errors = body?.errors || [];
    error.status = response.status;
    throw error;
  }

  return body.data;
};

export const subscribeToNewsletter = async (payload) => {
  const response = await axios.post(`${apiBase}/api/newsletter-subscriptions`, payload);
  return unwrapPublicResponse(response);
};

export const getNewsletterSubscriptions = async () => {
  const response = await axiosClient.get('/api/admin/newsletter-subscriptions');
  return unwrapApiResponse(response);
};

export const deleteNewsletterSubscription = async (id) => {
  const response = await axiosClient.delete(`/api/admin/newsletter-subscriptions/${id}`);
  return unwrapApiResponse(response);
};
